const META_INFO_ENUM = [
    { key: 'merchantName', label: 'Merchant Name' },
    { key: 'amount', label: 'Amount' },
    { key: 'latestDueDate', label: 'Due Date' },
    { key: 'orderId', label: 'Order ID' }
];

const TRANSACTION_INFO_ENUM = [
    { key: 'txnRefNumber', label: 'Txn Ref Number', component: 'TextCopy' },
    {
        key: 'transactionType',
        label: 'Transaction Type',
    },
    { key: 'payeeVpa', label: 'Payee Vpa' },
    { key: 'customerId', label: 'Customer Id' },
    { key: 'customerName', label: 'Customer Name' },
    { key: 'payerVpa', label: 'Payer Vpa' }
];

const RE_RAISE_CHARGEBACK_OPTIONS = [
    {
        name: 'Incorrect Document',
        value: 'ID',
        checked: false,
    },
    {
        name: 'Image Not Visible',
        value: 'INV',
        checked: false,
    },
    {
        name: 'Reason 3',
        value: 'Reason3',
        checked: false,
    },
    {
        name: 'Reason 4',
        value: 'Reason4',
        checked: false,
    },
];

export { TRANSACTION_INFO_ENUM, META_INFO_ENUM, RE_RAISE_CHARGEBACK_OPTIONS };
